/**
 * Main application initialization and UI component setup
 * 
 * Handles:
 * - Mobile sidebar navigation toggle and close functionality
 * - Nice Select dropdown initialization
 * - Responsive menu button behavior based on media queries
 * - Page preloader fade out animation
 * - Multiple Swiper carousel instances (recommend, trending, store, popular, gallery)
 * 
 * Mobile Detection:
 * @function isMobile() - Returns true if viewport width <= 959px
 * 
 * Sidebar Management:
 * @function closeSidebar() - Closes sidebar, removes active states, re-enables scroll
 * @event click .sidebar a - Auto-close sidebar on link click (mobile only)
 * @event click document - Auto-close sidebar on outside click (mobile only)
 * @event click .menu-btn - Toggle sidebar visibility
 * 
 * Sidebar Collapse Buttons:
 * @event click .sidebar-hider .icon-arrow-left - Hide sidebar with is-hide class
 * @event click .sidebar-hider .icon-arrow-right - Show sidebar with is-show class
 * 
 * Responsive Header Handler:
 * @function handleHeader(e) - Manages menu state based on media query (max-width: 959px)
 * @param {MediaQueryListEvent} e - Media query change event
 * 
 * Swiper Carousels Initialized:
 * - .js-recommend - Recommendation slider (1 slide per view)
 * - .js-trending - Trending slider (1 slide per view)
 * - .js-store - Store slider (1-5 slides responsive breakpoints)
 * - .js-popular - Popular slider (1-4 slides responsive breakpoints)
 * - .js-popular2 - Popular variant (1-3 slides responsive breakpoints)
 * - .js-gallery-small - Gallery thumbnails (2-4 slides responsive)
 * - .js-gallery-big - Main gallery with thumb sync
 * 
 * Common Swiper Options:
 * @property {number} spaceBetween - Space between slides (20-40px)
 * @property {number} speed - Slide transition speed (800ms)
 * @property {boolean} loop - Enable infinite loop
 * @property {boolean} watchOverflow - Disable if slides < view
 * @property {boolean} observer - Watch for DOM changes
 * @property {object} autoplay - Auto-advance with 5000ms delay
 * @property {object} pagination - Bullet navigation
 * @property {object} navigation - Arrow navigation buttons
 * 
 * @requires jQuery
 * @requires Swiper
 * @requires niceSelect plugin
 */
jQuery(document).ready(function ($) {

    //sidebar outside click prevent and after clicking automatically side bar close in
    const isMobile = () => window.matchMedia('(max-width: 959px)').matches;

    function closeSidebar() {
        $('.sidebar').removeClass('is-show');
        $('.menu-btn').removeClass('is-active');
        $('body').removeClass('no-scroll');
    }

    $(document).on('click', '.sidebar a', function () {
        if (isMobile()) closeSidebar();
    });

    $(document).on('click', function (e) {
        if (!isMobile()) return;
        const $t = $(e.target);
        const insideSidebar = $t.closest('.sidebar').length > 0;
        const onMenuBtn = $t.closest('.menu-btn').length > 0;
        if (!insideSidebar && !onMenuBtn) closeSidebar();
    });





    $('.js-select').niceSelect();
    $(document).on('click', '.menu-btn', function () {
        $(this).toggleClass('is-active');
        $('.sidebar').toggleClass('is-show');
    });

    const mediaHeader = window.matchMedia('(max-width: 959px)');

    function handleHeader(e) {
        if (e.matches) {
            $('.menu-btn').removeClass('is-active');
            $('.sidebar').removeClass('is-show');
            $(document).on('click', '.menu-btn', function () {
                $('body').toggleClass('no-scroll');
            });
        } else {
            $('.menu-btn').addClass('is-active');
            $('.sidebar').addClass('is-show');
            $('body').removeClass('no-scroll');
        }
    }





    $(".sidebar-hider .icon-arrow-left").click(function () {
        $(".sidebar").removeClass("is-show");
        $(".sidebar").addClass("is-hide");
        $(document).on('click', '.menu-btn', function () {
            $('body').toggleClass('no-scroll');
        });
    });


    $(".sidebar-hider .icon-arrow-right").click(function () {
        $(".sidebar").removeClass("is-hide");
        $(".sidebar").addClass("is-show");
    });



    /////////////////////////////////////////////////////////////////
    // Preloader
    /////////////////////////////////////////////////////////////////

    // Route transitions are handled by the React preloader component now.



    mediaHeader.addListener(handleHeader);
    handleHeader(mediaHeader);
    const recommendSlider = new Swiper('.js-recommend .swiper', {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        watchOverflow: true,
        observeParents: true,
        observeSlideChildren: true,
        observer: true,
        speed: 800,
        autoplay: {
            delay: 5000
        },
        navigation: {
            nextEl: '.js-recommend .swiper-button-next',
            prevEl: '.js-recommend .swiper-button-prev'
        },
        pagination: {
            el: '.js-recommend .swiper-pagination',
            type: 'bullets',
            // 'bullets', 'fraction', 'progressbar'
            clickable: true
        }
    });
    const trendingSlider = new Swiper('.js-trending .swiper', {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        watchOverflow: true,
        observeParents: true,
        observeSlideChildren: true,
        observer: true,
        speed: 800,
        autoplay: {
            delay: 5000
        },
        navigation: {
            nextEl: '.js-trending .swiper-button-next',
            prevEl: '.js-trending .swiper-button-prev'
        },
        pagination: {
            el: '.js-trending .swiper-pagination',
            type: 'bullets',
            // 'bullets', 'fraction', 'progressbar'
            clickable: true
        }
    });



    const popularStore = new Swiper('.js-store .swiper', {
        slidesPerView: 1,
        spaceBetween: 25,
        loop: true,
        watchOverflow: true,
        observeParents: true,
        observeSlideChildren: true,
        observer: true,
        speed: 800,
        autoplay: {
            delay: 5000
        },
        navigation: {
            nextEl: '.js-store .swiper-button-next',
            prevEl: '.js-store .swiper-button-prev'
        },
        pagination: {
            el: '.js-store .swiper-pagination',
            type: 'bullets',
            // 'bullets', 'fraction', 'progressbar'
            clickable: true
        },
        breakpoints: {
            575: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            1199: {
                slidesPerView: 4,
                spaceBetween: 25
            },
            1599: {
                slidesPerView: 5,
                spaceBetween: 25
            }
        }
    });






    const popularSlider = new Swiper('.js-popular .swiper', {
        slidesPerView: 1,
        spaceBetween: 25,
        loop: false,
        watchOverflow: true,
        observeParents: true,
        observeSlideChildren: true,
        observer: true,
        speed: 800,
        autoplay: {
            delay: 5000
        },
        navigation: {
            nextEl: '.js-popular .swiper-button-next',
            prevEl: '.js-popular .swiper-button-prev'
        },
        pagination: {
            el: '.js-popular .swiper-pagination',
            type: 'bullets',
            // 'bullets', 'fraction', 'progressbar'
            clickable: true
        },
        breakpoints: {
            575: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            1199: {
                slidesPerView: 2,
                spaceBetween: 25
            },
            1599: {
                slidesPerView: 4,
                spaceBetween: 25
            }
        }
    });



    const popularSlider2 = new Swiper('.js-popular2 .swiper', {
        slidesPerView: 1,
        spaceBetween: 25,
        loop: true,
        watchOverflow: true,
        observeParents: true,
        observeSlideChildren: true,
        observer: true,
        speed: 800,
        autoplay: {
            delay: 5000
        },
        navigation: {
            nextEl: '.js-popular2 .swiper-button-next',
            prevEl: '.js-popular2 .swiper-button-prev'
        },
        pagination: {
            el: '.js-popular2 .swiper-pagination',
            type: 'bullets',
            // 'bullets', 'fraction', 'progressbar'
            clickable: true
        },
        breakpoints: {
            575: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            1199: {
                slidesPerView: 2,
                spaceBetween: 25
            },
            1599: {
                slidesPerView: 3,
                spaceBetween: 25
            }
        }
    });




    const gallerySmall = new Swiper('.js-gallery-small .swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        watchOverflow: true,
        observeParents: true,
        observeSlideChildren: true,
        observer: true,
        speed: 800,
        pagination: {
            el: '.js-gallery-small .swiper-pagination',
            type: 'bullets',
            // 'bullets', 'fraction', 'progressbar'
            clickable: true
        },
        breakpoints: {
            575: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            767: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1599: {
                slidesPerView: 4,
                spaceBetween: 20
            }
        }
    });
    const galleryBig = new Swiper('.js-gallery-big .swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        watchOverflow: true,
        observeParents: true,
        observeSlideChildren: true,
        observer: true,
        speed: 800,
        thumbs: {
            swiper: gallerySmall
        }
    });
});
